var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import { useNavigate } from "react-router-dom";
import AppId from "@domains/utils/AppId";
import RegisteredDevicesData from "./RegisteredDevicesData";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var RegisteredDevices = function (props) {
    var device = DeviceContext();
    var navigate = useNavigate();
    var appid = AppId();
    var _a = __read(useState(false), 2), registeredDevicepopup = _a[0], setRegisteredDevicepopup = _a[1];
    var _b = __read(useState(false), 2), registerThisDevice = _b[0], setRegisterThisDevice = _b[1];
    // const [deviceLimit, setDeviceLimit] = useState(false);
    var accData = JSON.parse(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("acc_data"));
    // accData.prfId ="" ;
    var RegisteredDevicesData1 = [
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "DMSansNormal_20_400 txt-midnight-blue" },
                    "Registered ",
                    React.createElement("strong", null, " Devices")))),
            eventKey: "RegisterDevices",
            tabContent: (React.createElement(React.Fragment, null, (accData === null || accData === void 0 ? void 0 : accData.prfId) && (accData === null || accData === void 0 ? void 0 : accData.prfId) !== " " && (React.createElement(RegisteredDevicesData, null)))),
        },
    ];
    return (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null,
        device && device.isMobile && registeredDevicepopup && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-genericSidebar" },
                React.createElement(GenericDrawer, { show: registeredDevicepopup, setShow: setRegisteredDevicepopup, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                        React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Register This Device")), bodyComp: React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "DMSanN_14_400 txt-midnight-blue px-3 pt-4 pb-4 text-center line-20" },
                            "You are going to register this device. You can avail",
                            React.createElement("br", null),
                            " benefits like: ",
                            React.createElement("br", null),
                            " receiving relevant notifications without logging in."),
                        React.createElement(Row, { className: "px-3 pb-3 pt-3" },
                            React.createElement(Col, { className: "col-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", className: "w-100", onClick: function () { return setRegisteredDevicepopup(false); } })),
                            React.createElement(Col, { className: "col-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Register Device", className: "w-100 px-0", onClick: function (e) {
                                        e.stopPropagation();
                                        props.deviceRegister();
                                    } })))) })))),
        device && device.isDesktop && props.deviceLimit && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-basic-profile mb-genericSidebar" },
                React.createElement(GenericDrawer, { show: props.deviceLimit, setShow: props.setDeviceLimit, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                        React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Forget this device")), bodyComp: React.createElement(React.Fragment, null,
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 12 },
                                React.createElement("p", { className: "DMSanN_14_400 txt-midnight-blue px-3 pt-3 text-center" }, "A maximum of 10 devices is already registered on your account. Hence, your account is deregistered from 1st device as you registered from a new device."))),
                        React.createElement(Row, { className: "px-3 pb-3 pt-3" },
                            React.createElement(Col, { className: "col-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "No", className: "w-100", onClick: function () { return props.setDeviceLimit(false); } })),
                            React.createElement(Col, { className: "col-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Yes", className: "w-100 px-0", onClick: props === null || props === void 0 ? void 0 : props.deleteOldDevice() })))) }))))))));
};
export default RegisteredDevices;
